<template>
  <v-form>
    <gg-text-field
      outlined
      label="Current Password"
      v-model="model.current_password"
      :type="showPass ? 'text' : 'password'"
      :error-messages="errors.collect('Current Password')"
      v-validate="'required'"
      name="Current Password"
      class="compact-password"
    >
      <template v-slot:append>
        <v-btn
          icon
          :ripple="false"
          class="mt-0 mr-1"
          @click="showPass = !showPass"
        >
          <v-icon color="#C2C2C2">{{ showPass ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
        </v-btn>
      </template>
    </gg-text-field>
    <compact-password
      outlined
      label="New Password"
      v-validate="'required|no_quotes'"
      data-vv-name="password"
      data-vv-as="New Password"
      :error-messages="errors.collect('password')"
      with-generator
      v-model="model.new_password"
      ref="newPwd"
      @input-type="updateShowNewPassword"
    />
    <gg-text-field
      outlined
      label="New Password Confirmation"
      v-model="model.new_password_confirm"
      :type="showNewPass ? 'text' : 'password'"
      :error-messages="errors.collect('New Password Confirmation')"
      v-validate="'required|confirmed:newPwd|no_quotes'"
      name="New Password Confirmation"
      class="compact-password"
    />
    <gg-btn
      color="primary"
      class="my-4 ml-0 mt-1"
      @click="changePassword"
      :loading="loading"
    >
      Change Password
      <span class="visually-hidden text-lowercase">button</span>
    </gg-btn>
  </v-form>
</template>

<script>
import debounce from 'lodash.debounce'
import { Validator } from 'vee-validate'
import { mapActions } from 'vuex'
import { passStrengthValidator, noQuotesValidator } from '@/helpers/validators'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'ChangePasswordForm',
  components: {
    CompactPassword
  },
  data () {
    return {
      model: {
        current_password: '',
        new_password: '',
        new_password_confirm: ''
      },
      loading: false,
      strength: 0,
      showPass: false,
      showNewPass: false,
      showPopover: false,
      showProtectHint: false,
      showGuessHint: false,
    }
  },
  computed: {
    passColor () {
      if (this.strength < 20) {
        return 'red lighten-1'
      } else if (this.strength < 40) {
        return 'warning'
      } else if (this.strength < 60) {
        return 'amber'
      } else if (this.strength < 80) {
        return 'green lighten-2'
      }
      return 'green darken-1'
    },
  },
  methods: {
    ...mapActions([
      'verifyPasswordStrength',
      'setProfilePassword',
      'setHostingPassword',
      'reportError',
      'reportSuccess'
    ]),
    async getStrength () {
      try {
        if (this.model.new_password) {
          const { strength } = await this.verifyPasswordStrength(this.model.new_password)
          if (strength) {
            this.strength = strength
            await this.$validator.validate('New Password')
          }
        } else {
          this.strength = 0
        }
      } catch (e) {
        console.warn(e)
      }
    },
    setPassword (pass) {
      this.model.new_password = pass
      this.model.new_password_confirm = pass
    },
    updateShowNewPassword (inputType) {
      this.showNewPass = inputType !== 'password'
    },
    reset () {
      this.model.current_password = ''
      this.model.new_password = ''
      this.model.new_password_confirm = ''
      this.strength = 0
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    async changePassword () {
      if (!await this.$validator.validateAll()) return
      this.loading = true
      const data = {
        ...this.model,
        new_password_confirm: this.model.new_password
      }
      try {
        const { resultmsg } = await this.setProfilePassword(data)
        this.loading = false
        this.reset()
        this.reportSuccess(resultmsg)
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
  },
  watch: {
    'model.new_password': debounce(function () {
      this.getStrength()
    }, 500)
  },
  created () {
    Validator.extend('pass_strength', passStrengthValidator)
    Validator.extend('no_quotes', noQuotesValidator)
  },
}
</script>
